module.exports = {
  BANK_ERROR: 'BE08',
  FRAUD: 'FR01',
  REQUEST_BY_CUSTOMER: 'MD06',
  SPECIFIC_SERVICE: 'SL02'
};
